import './banner.css';
export default {
  "banner": "pf-v6-c-banner",
  "button": "pf-v6-c-button",
  "modifiers": {
    "danger": "pf-m-danger",
    "success": "pf-m-success",
    "warning": "pf-m-warning",
    "info": "pf-m-info",
    "custom": "pf-m-custom",
    "red": "pf-m-red",
    "orangered": "pf-m-orangered",
    "orange": "pf-m-orange",
    "yellow": "pf-m-yellow",
    "green": "pf-m-green",
    "teal": "pf-m-teal",
    "blue": "pf-m-blue",
    "purple": "pf-m-purple",
    "sticky": "pf-m-sticky",
    "disabled": "pf-m-disabled",
    "inline": "pf-m-inline"
  }
};